import CancellableRequest from '../../services/cancellable-request';
import { UserCurrentCompany } from '../../services/user-company';
import { getUserCompanies as fetchUserCompanies } from '../../api/auth';
import { AccessToken } from '../../services/access-token';
import { SET_USER_COMPANIES } from '../../consts/action-types';
import { UserImpersonation } from '../../services/user-impersonation';
import { currentSSOService } from '../../services/sso-auth-service/CurrentSSOService';
import { unleashClient } from '../../services/UnleashProvider/const';
import { UserCompany } from '../../api/types/UserCompany.types';
import HttpError from '../../services/http-service/HttpError';

const companiesRequest = new CancellableRequest();
type Dispatch = (action: any) => void;

export const getUserCompanies = () => async (dispatch: Dispatch) => {
  AccessToken.setTokensFromCookies();

  if (!AccessToken.getToken()) {
    UserCurrentCompany.removeCompanyFromCookies();
    UserImpersonation.clearImpersonationDataFromCookies();
    AccessToken.clearRefreshToken();
    throw new Error('No token');
  }
  currentSSOService.initializeSSOService();
  UserCurrentCompany.setCompanyFromCookies();
  UserImpersonation.setImpersonationDataFromCookies();

  let companies: UserCompany[] = [];
  try {
    companies = await companiesRequest.send(fetchUserCompanies, null);
  } catch (error) {
    if (error instanceof HttpError && error.isRequestCancelError) return;
    throw error;
  }

  const currentCompany = companies.find(company => company.current);
  if (!currentCompany) return Promise.reject(new Error('No current company found'));

  UserCurrentCompany.setCompany(currentCompany.id);
  const unleashContext = await unleashClient.getContext();

  if (!unleashContext.properties?.company_id) {
    await unleashClient.updateContext({
      ...unleashContext,
      properties: {
        ...unleashContext.properties,
        company_id: currentCompany.id.toString()
      }
    });
  }
  return dispatch({ type: SET_USER_COMPANIES, payload: { current: currentCompany, companies } });
};
